import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import $ from "jquery";
import "../../../../../../css/workspace.css";
import {
    Button,
  } from "antd";
import {
    AppstoreOutlined,
    ArrowLeftOutlined,
  } from "@ant-design/icons";

import UploadSpace from './upload/index';
import GuardrailsSpace from './guardrails/index';
import AskAICoach from './askAICoach/index';
import IntegrationSpace from './integration/index';
import { getWalkthroughs } from "../../../../../../redux/actions/collectionsV2";
import { useDispatch} from "react-redux";
const CollectionWorkspace = () => {

  useEffect(() => {
    $(".sidebar-global").hide();
  });

  useEffect(() => {
    dispatch(getWalkthroughs(new URLSearchParams(queryParams).get("name")));
  },[]);

  const history = useHistory();
  const queryParams = useLocation().search;
  const collectionName =  new URLSearchParams(queryParams).get("name");
  const dispatch = useDispatch();

  const [expandedBox, setExpandedBox] = useState(null);

    return (
        <div className="workspace">
          <div className="wk-title-flex">
            <div className="flex-title-back">
              <button 
               onClick={(e) => history.push(`/dashboard/skills/collections`)}
               className="back-btn"><ArrowLeftOutlined /> Back</button>
              <h1>Collection Workspace</h1>
            </div>            
            <Button
              type="primary"
              icon={<AppstoreOutlined />}
              className="ant-btn-gradient"
              onClick={(e) => history.push(`/collections?name=${collectionName}`)}
            >
              Switch to Classic View
            </Button>
          </div>
          <div className="flex-grid">
            <UploadSpace expandedBox={expandedBox} setExpandedBox={setExpandedBox}/>
            <GuardrailsSpace expandedBox={expandedBox} setExpandedBox={setExpandedBox}/>
            <AskAICoach expandedBox={expandedBox} setExpandedBox={setExpandedBox}/>
            <IntegrationSpace expandedBox={expandedBox} setExpandedBox={setExpandedBox}/>
          </div>
        </div>
      );
}

export default CollectionWorkspace;
